
import React from 'react';
import AppLayout from '@/components/layout/AppLayout';
import Orientation from '@/components/application/Orientation';
import ApplicationStepper from '@/components/application/ApplicationStepper';

const OrientationPage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 md:px-8 pb-8">
        <ApplicationStepper />
        
        <h1 className="text-2xl font-bold mb-2 text-jungle text-center md:text-2xl">Orientation</h1>
        <p className="text-gray-600 mb-8 text-center">
          Choose a convenient time for your orientation session
        </p>
        
        <div className="max-w-2xl mx-auto">
          <Orientation />
        </div>
      </div>
    </AppLayout>
  );
};

export default OrientationPage;
